import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faIdBadge } from "@fortawesome/free-solid-svg-icons"

export const IdBadge = (props) => {
  return <FontAwesomeIcon faIcon={faIdBadge} {...props} />
}
